import { render, staticRenderFns } from "./TextCopy.vue?vue&type=template&id=1f383617&scoped=true&"
import script from "./TextCopy.vue?vue&type=script&lang=js&"
export * from "./TextCopy.vue?vue&type=script&lang=js&"
import style0 from "./TextCopy.vue?vue&type=style&index=0&id=1f383617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f383617",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f383617')) {
      api.createRecord('1f383617', component.options)
    } else {
      api.reload('1f383617', component.options)
    }
    module.hot.accept("./TextCopy.vue?vue&type=template&id=1f383617&scoped=true&", function () {
      api.rerender('1f383617', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/data/components/TextCopy.vue"
export default component.exports